module.exports = __webpack_public_path__ + "static/media/Nuance-logo.dc9cf2ce.png";